import React from 'react';

import Layout from '../../../components/global/Layout';
import PlaceSelection from '../../../components/PlaceSelection';

const BulkItemUpdates = ({ history }) => (
  <Layout>
    <PlaceSelection
      claimStatus="NONE"
      hasServiceSetting
      heading="Bulk Item Updates"
      handleSelect={value =>
        history.push(`/bulk-menu-item/${encodeURIComponent(value.name)}`)
      }
    />
  </Layout>
);

export default BulkItemUpdates;
